// extracted by mini-css-extract-plugin
export default {"container":"products_container__VDD1G","products":"products_products__bAiZQ","menu":"products_menu__2cwZx","list":"products_list__9DO7h","product":"products_product__0b9gq"};